import proyecto from "../../api/Proyecto";

export const getMarcas = async ({ q = "", activos = "1" } = {}) => {
  const res = await proyecto.get("/marcas", { params: { q, activos } });
  return res.data;
};

export const crearMarca = async (payload) => {
  const res = await proyecto.post("/marcas", payload);
  return res.data;
};

export const actualizarMarca = async (id, payload) => {
  const res = await proyecto.put(`/marcas/${id}`, payload);
  return res.data;
};

export const desactivarMarca = async (id) => {
  const res = await proyecto.delete(`/marcas/${id}`);
  return res.data;
};

